<div mat-dialog-title class="title">
    Sửa thông tin người dùng
</div>
<mat-dialog-content>
    <div class="pt-5 ">
        <form [formGroup]="form">
            <div class="form-control">
                <div class="flex mb-2">
                    <label for="" class="whitespace-nowrap min-w-[40%]">Khu vực giới thiệu</label>
                    <div class="w-full">
                        <ng-select class="w-full text-base ng-select-custom" formControlName="leadRegion"
                            notFoundText="Chọn khu vực">
                            <ng-option *ngFor="let region of regions" [value]="region">{{region}}</ng-option>
                        </ng-select>
                        <div class="h-6">
                            <div class="invalid-feedback ms-3" *ngIf="checkValidators(form.get('leadRegion'))">
                                {{getErrorMessage(form.get('leadRegion'))}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex mb-2">
                    <label for="" class="whitespace-nowrap min-w-[40%]">Tỉnh giới thiệu</label>
                    <div class="w-full">
                        <ng-select class="w-full text-base ng-select-custom" formControlName="leadProvince"
                            notFoundText="Chọn vùng">
                            <ng-option *ngFor="let province of provinces" [value]="province">{{province}}</ng-option>
                        </ng-select>
                        <div class="h-6">
                            <div class="invalid-feedback ms-3" *ngIf="checkValidators(form.get('leadProvince'))">
                                {{getErrorMessage(form.get('leadProvince'))}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex mb-2">
                    <label for="" class="whitespace-nowrap min-w-[40%]">Khu vực bạn phát triển</label>
                    <div class="w-full">
                        <ng-select class="w-full text-base ng-select-custom" formControlName="selfRegion"
                            notFoundText="Chọn khu vực">
                            <ng-option *ngFor="let region of regions" [value]="region">{{region}}</ng-option>
                        </ng-select>
                        <div class="h-6">
                            <div class="invalid-feedback ms-3" *ngIf="checkValidators(form.get('selfRegion'))">
                                {{getErrorMessage(form.get('selfRegion'))}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex mb-2">
                    <label for="" class="whitespace-nowrap min-w-[40%]">Tỉnh bạn phát triển</label>
                    <div class="w-full">
                        <ng-select class="w-full text-base ng-select-custom" formControlName="selfProvince"
                            notFoundText="Chọn vùng">
                            <ng-option *ngFor="let province of provinces" [value]="province">{{province}}</ng-option>
                        </ng-select>
                        <div class="h-6">
                            <div class="invalid-feedback ms-3" *ngIf="checkValidators(form.get('selfProvince'))">
                                {{getErrorMessage(form.get('selfProvince'))}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions w-full">
    <button class="text-base whitespace-nowrap" mat-button cdkFocusInitial (click)="onSubmit()">
        Xác nhận
    </button>
</mat-dialog-actions>